import React, {
  useContext,
  useEffect,
  useLayoutEffect,
  useMemo,
  useState,
} from "react";
import { useLocation, useParams } from "react-router-dom";
import {
  Area1Set,
  Area2Set,
  FullviewerSet,
  ModalcolorSet,
  ModeSet,
  ShowratioSet,
  Static2Map1Set,
  Static2Map2Set,
  Year1Set,
  Year2Set,
  Zoomhanrei1Set,
  Zoomlevel1Set,
} from "../App";

import { RendouSet, StartmodalSet, SyosaiSet, SyukurenSet } from "../App";
import data_meta1 from "../geograph/metadatas/meta_data_20260211";
import meta_mieruka from "./meta_mieruka_20260121";
let data_meta = data_meta1.concat(meta_mieruka);

import { MierukaFooter } from "./mierukaFooter";
import { MierukaHeader } from "./mierukaHeader";

import { ModalColorset } from "./modalColorset";

let filecheck = 0;

export const Map3 = () => {
  const { fullviewerset, setFullviewerSet } = useContext(FullviewerSet);
  const { modeset, setModeSet } = useContext(ModeSet);
  const { startmodalset, setStartmodalSet } = useContext(StartmodalSet);
  const [showcityset, setShowcityset] = useState(false);
  const [filecheckset, setFilecheckset] = useState(0);
  const { static2map1set, setStatic2Map1Set } = useContext(Static2Map1Set);
  const { static2map2set, setStatic2Map2Set } = useContext(Static2Map2Set);
  const { area1set, setArea1Set } = useContext(Area1Set);
  const { area2set, setArea2Set } = useContext(Area2Set);
  const { year1set, setYear1Set } = useContext(Year1Set);
  const { year2set, setYear2Set } = useContext(Year2Set);
  const { zoomlevel1set, setZoomlevel1Set } = useContext(Zoomlevel1Set);
  const { zoomhanrei1set, setZoomhanrei1Set } = useContext(Zoomhanrei1Set);
  const { rendouset, setRendouSet } = useContext(RendouSet);
  const { syukurenset, setSyukurenSet } = useContext(SyukurenSet);
  const { syosaiset, setSyosaiSet } = useContext(SyosaiSet);
  const { modalcolorset, setModalcolorSet } = useContext(ModalcolorSet);
  const { showratioset, setShowratioSet } = useContext(ShowratioSet);
  // const { alpha1set, setAlpha1Set } = useContext(Alpha1Set);
  // const { alpha2set, setAlpha2Set } = useContext(Alpha2Set);

  const params = useParams();
  const location = useLocation();
  const locationsetting = decodeURI(location.search).split("_");
  const metatmp = data_meta.filter((r) => {
    return r.no == params.no;
  });
  const meta = useMemo(() => metatmp[0], [metatmp[0]]);

  useLayoutEffect(() => {
    // console.log(meta);
  }, [area1set, meta]);

  useLayoutEffect(() => {
    if (params.mode == 9999999) {
      setFullviewerSet(true);
    } else {
      setFullviewerSet(false);
    }
    if (params.mode == 9999999) {
      if (params.area) {
        setArea1Set(params.area);
        if (locationsetting[1]) {
          setArea2Set(locationsetting[1]);
        } else {
          setArea2Set(params.area);
        }
      }
      if (locationsetting[2]) {
        setYear1Set(Number(locationsetting[2]));
      }
      if (locationsetting[3]) {
        setYear2Set(Number(locationsetting[3]));
      }
    }
    if (params.mode) {
      var mode = params.mode;
      setModeSet(Number(mode));
    }
  }, [params.mode]);

  // ファイルなしアラート //////////////

  const metadata = static2map1set;
  // const metadatatmp = JSON.stringify(static2map1set);
  // const metadata = JSON.parse(metadatatmp);
  const year = year1set || metadata.year5;

  let area = "福岡県糸島市";
  if (area1set) {
    area = area1set.normalize("NFD");
  }

  let csv_name = "人口総数×人口総数";
  if (metadata.csv_filename) {
    csv_name = metadata.csv_filename.normalize("NFD");
  }

  useEffect(() => {
    function csvcheck(no, year, area, csv_name) {
      fetch(
        "/csv/" + no + "/" + area + "_" + csv_name + "_" + year + ".csv",
        {},
      )
        .then((r) => {
          if (!r.ok) {
            throw new Error();
          }
          return r.text();
        })
        .then((r) => {
          if (r.startsWith("<")) {
            filecheck = filecheck + 1;
            setFilecheckset(filecheckset + 2);
          } else {
            filecheck = filecheck + 100;
            setFilecheckset(filecheckset + 100);
          }
          return r;
        });
    }
    csvcheck(metadata.no, metadata.year5, area, csv_name);
  }, [
    // filecheckset
    static2map1set,
    area1set,
    modeset,
  ]);
  // ファイルなしアラート //////////////
  useEffect(() => {
    setTimeout(() => {
      if (filecheck > 1) {
        if (filecheck < 50) {
          window.alert(
            "この地域にはデータがありません。市町村名を確認してください。",
          );
        }
      }
    }, 3000);
  }, [area1set, area2set]);

  useLayoutEffect(() => {
    const metatmpt = data_meta.filter((r) => {
      return r.no == params.no;
    });
    setStatic2Map1Set(metatmpt[0]);
  }, [static2map1set]);

  useLayoutEffect(() => {
    const metatmpt = data_meta.filter((r) => {
      return r.no == params.no;
    });
    setStatic2Map2Set(metatmpt[0]);
  }, [static2map2set]);

  let buttons = <></>;

  if (params.mode == 9999999) {
    // 地域を選ぶ
    buttons = (
      <>
        <MierukaHeader />
        <MierukaFooter metadata={meta} />
        <div className="absolute z-40">
          <ModalColorset
            metadata={metadata}
            show={modalcolorset}
            setShow={setModalcolorSet}
          />
        </div>
        {/* 3Dマウス開発 */}
        {/* <GamepadTest /> */}
      </>
    );
  } else {
    //
  }

  return <>{buttons}</>;
};
